//type.js

export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILED = 'FAILED';

console.log('type called')